import React, { FC } from 'react'
import { Link as RouteLink } from 'react-router-dom'
import { Typography } from '@mui/material'
import { Formik } from 'formik'
import { routes } from 'config'
import { IFormProps, isMultiLoginApp } from 'utils'
import {
  Module,
  ModuleHeader,
  ModuleBody,
  CustomAlert,
  CustomTextField,
  CustomButton,
  ButtonContainer,
} from 'components'

const ForgotLoginNameForm: FC<IFormProps> = ({
  initialValues,
  validationSchema,
  handleSubmit,
  serviceError,
}) => {
  const titleLogin = isMultiLoginApp()
    ? 'Recover Your Multi Login Name'
    : 'Recover Your Login Name'

  const forgotLoginText = isMultiLoginApp()
    ? 'You can recover your Multi Login Name using the email address associated with your account.'
    : 'You can recover your Bright MLS Login Name using the email address associated with your account.'

  return (
    <Module>
      <ModuleHeader title={titleLogin}>
        <Typography variant="body1">{forgotLoginText}</Typography>
        <CustomAlert severity="error">{serviceError}</CustomAlert>
      </ModuleHeader>

      <ModuleBody>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({
            handleSubmit: onSubmit,
            dirty,
            isValid,
            isSubmitting,
            getFieldProps,
            getFieldMeta,
            setFieldTouched,
            setFieldError,
            touched,
            errors,
            values,
          }) => (
            <form onSubmit={onSubmit}>
              <CustomTextField
                autoFocus
                id="email"
                label="Email address"
                placeholder="Ex: Joe@realestate.com"
                hasServiceError={Boolean(serviceError)}
                touched={touched}
                errors={errors}
                values={values}
                getFieldMeta={getFieldMeta}
                setFieldTouched={setFieldTouched}
                setFieldError={setFieldError}
                {...getFieldProps('email')}
              />

              <ButtonContainer
                primary={
                  <CustomButton
                    type="submit"
                    disabled={!dirty || !isValid || isSubmitting}
                  >
                    Recover Login Name
                  </CustomButton>
                }
                secondary={
                  isMultiLoginApp() ? (
                    <RouteLink to={routes.multiLogin}>
                      Return To Multi Login
                    </RouteLink>
                  ) : (
                    <RouteLink to={routes.login}>Return To Login</RouteLink>
                  )
                }
              />
            </form>
          )}
        </Formik>
      </ModuleBody>
    </Module>
  )
}

export default ForgotLoginNameForm
